<template>
  <card>
    <card-header :title="$t('settings.general_settings')">
      <p class="card-header-icon" aria-label="more options">
        <mat-icon icon="mdi-pencil" v-if="edit"></mat-icon>
        <a @click="beginEdit()" v-else>{{ $t('editing.edit') }}</a>
      </p>
    </card-header>
    <card-content>
      <form>
        <fieldset :disabled="!edit">
          <div class="field">
            <label class="label">{{ $t('settings.lang') }}</label>
            <div class="control">
              <div class="control has-icons-left">
                <div class="select">
                  <select v-model="selected">
                    <option 
                      v-for="(locale, key) in locales" 
                      :key="key" 
                      :value="key"
                    >{{ locale }}</option>
                  </select>
                </div>
                <span class="icon is-left">
                  <i class="mdi mdi-web mdi-24px"></i>
                </span>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </card-content>
    <card-footer v-if="edit">
      <a class="card-footer-item" @click="save()">{{ $t('editing.save') }}</a>
      <a class="card-footer-item" @click="endEdit()">{{ $t('editing.cancel') }}</a>
    </card-footer>
  </card>
</template>
<script>
import locale from "@/services/locale";
import profile from "@/services/profile";
import { loadLocale } from "@/i18n";
import { localize } from "vee-validate";
export default {
  name: "CommonSettings",
  data() {
    return {
      edit: false,
      selected: this.$i18n.locale,
      locales: null
    };
  },
  created: function () {
    var map = {};
    locale.getSupportedLanguages().then(
      resp => {
        console.log(resp.data);
        for (var key of Object.keys(resp.data)) {
          map[key] = resp.data[key];
        }
        this.locales = map;
      },
      err => {
        console.log(err);
        this.locales = map;
      }
    );
  },
  methods: {
    beginEdit() {
      this.edit = true;
    },
    endEdit() {
      this.edit = false;
    },
    save() {
      if (this.selected != this.$store.getters.locale) { 
        loadLocale(this.selected, function(messages) {
          localStorage.setItem("localeMessages", JSON.stringify(messages));
          localize(messages.validations.code, messages.validations);     
        });
        this.$cookies.set("lang", this.selected,"30d", "/", "", "", "");
        localStorage.setItem("locale", this.selected);
        this.$store.dispatch("setLocale", this.selected);
        this.$i18n.locale = this.selected;
        document.title =  this.$i18n.t("topbar.account");
        profile.setUserLang(this.selected).then(
          () => {
            this.endEdit();
          },
          err => {
            console.log(err);
          }
        );   
      } else {
        this.endEdit();
      }
    }
  }
};
</script>
